<template>
  <div class="statistics d-flex p-3 flex-column flex-md-row">
    <div class="element py-2 px-md-3 w-100">
      <p class="text-primary mb-0">
        {{ `✅  ${statistics.numberOfRegistrants > 0 ? statistics.numberOfRegistrants : ""}` }}
      </p>
      <small>{{
        trans(
          `streams.dashboard.web_class_modal.${
            checkNoValue(statistics.numberOfRegistrants) ? "no_" : ""
          }registered`
        )
      }}</small>
    </div>
    <div class="element py-2 px-md-3 w-100">
      <p class="text-primary mb-0">
        {{ `🎓 ${statistics.numberOfAttendees ? statistics.numberOfAttendees : ""}` }}
      </p>
      <small>{{
        trans(
          `streams.dashboard.web_class_modal.${
            checkNoValue(statistics.numberOfAttendees) ? "no_" : ""
          }attended`
        )
      }}</small>
    </div>
    <div class="py-2 px-md-3 w-100">
      <p class="text-primary mb-0">
        {{ `❤️ ${statistics.rating ? `${statistics.rating}/5` : ""}` }}
      </p>
      <small>{{
        trans(
          `streams.dashboard.web_class_modal.${checkNoValue(statistics.rating) ? "no_" : ""}rating`
        )
      }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebClassStatistics",
  props: {
    statistics: Object,
  },
  methods: {
    checkNoValue(value) {
      return value === 0;
    },
  },
};
</script>

<style scoped lang="scss">
.statistics {
  background-color: $color-light;
  border-radius: 1rem;

  .element {
    border-right: 1px solid $color-dark-600;
    @media (max-width: 768px) {
      border-right: 0;
      border-bottom: 1px solid $color-dark-600;
    }
  }
}
</style>
